import { useState, useEffect } from 'react';
import { supabase } from '../../supabase/config';
import { useNavigate } from 'react-router-dom';
import { ExternalLink, LogOut } from 'lucide-react';
import { Button } from './shared/Button';

const AdminHeader = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/admin/login');
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-slate-900 border-b border-slate-700 h-16 z-40">
      <div className="h-full px-6 flex items-center justify-between">
        <div className="text-xl font-bold text-white">
          Portfolio Admin
        </div>
        
        <div className="flex items-center gap-4">
          {user && (
            <span className="text-slate-400 text-sm">
              {user.email}
            </span>
          )}
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-sm"
          >
            <ExternalLink size={18} />
            View Site
          </a>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLogout}
            className="flex items-center gap-2"
          >
            <LogOut size={18} />
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;

